var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isShowPhoto)?_c('DrawablePhotoV1OrV2',{attrs:{"image":_vm.imageObj,"drawing":_vm.drawing,"title":_vm.$t('Annotate image'),"remove-button-title":_vm.$t('Remove annotation'),"can-be-deleted":false},on:{"change":_vm.updateDrawing}}):_c('p',[_vm._v(_vm._s(_vm.$t('No image set to annotate.')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }